import QuanLyNhanSu from "./quan-ly-nhan-su/QuanLyNhanSu";
import BaoCaoThongKe from "./bao-cao-thong-ke/BaoCaoThongKe";
import DeXuat from "./de-xuat/DeXuat";
import KeHoach from "./ke-hoach/KeHoach";

export const danhSachTabCGKT = () => [
  {
    eventKey: "0",
    title: "Đề xuất",
    component: <DeXuat/>,
  },
  {
    eventKey: "1",
    title: "Kế hoạch",
    component: <KeHoach/>,
  },
  {
    eventKey: "2",
    title: "Nhân sự",
    component: <QuanLyNhanSu />,
  },
  {
    eventKey: "3",
    title: "Báo cáo thống kê",
    component: <BaoCaoThongKe />,
  },
];
